import React from "react";

import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionHeaderName,
} from "@transfr-inc/dashboard-components";
import LessonsMasteriesTable from "./lessons-masteries.table";
import "./unit-lesson-accordion.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

export function UnitLessonAccordion({
  lesson,
  isExpanded,
  lessonIndex,
  responsiveStyles,
  courseId,
  courseName,
  unitName,
  unitIndex,
  credentialData,
  unitId,
  completionMap,
  classroomId,
  courseData,
  activityDependencies,
  preqEnabled,
  isTraineePage = false,
}) {
  const allCompleted = lesson?.completed;
  const isLocked = courseData?.prerequisitesEnabled ? lesson?.locked : false;

  return (
    <Accordion
      className="unit-lesson-accordion"
      isOpen={(isTraineePage || !isLocked) && isExpanded}
    >
      <div className="unit-lesson-accordion-header">
        <AccordionHeader>
          <AccordionHeaderName>
            <div className="unit-lesson-accordion-header-name">
              <div>
                Lesson {lessonIndex}: {lesson?.title}
              </div>
              <div
                className={clsx(
                  "completed-cell",
                  allCompleted && "completed",
                  isLocked && "locked"
                )}
              >
                {allCompleted ? (
                  <FontAwesomeIcon icon="fa-solid fa-circle-check" />
                ) : isLocked ? (
                  <FontAwesomeIcon icon="fa-regular fa-lock" />
                ) : (
                  <FontAwesomeIcon icon="fa-regular fa-circle" />
                )}
              </div>
            </div>
          </AccordionHeaderName>
        </AccordionHeader>
      </div>
      <AccordionBody>
        <LessonsMasteriesTable
          lesson={lesson}
          responsiveStyles={responsiveStyles}
          courseId={courseId}
          courseName={courseName}
          unitName={unitName}
          unitIndex={unitIndex}
          credentialData={credentialData}
          unitId={unitId}
          completionMap={completionMap}
          classroomId={classroomId}
          courseData={courseData}
          lessonIndex={lessonIndex}
          activityDependencies={activityDependencies}
          prereqEnabled={preqEnabled}
          isTraineePage={isTraineePage}
        />
      </AccordionBody>
    </Accordion>
  );
}
